import createListStore from '@product-framework/store/createListStore';

export const LIST_STORE = 'managedNumberListStore';
const ManagedNumberListStore = createListStore(LIST_STORE);
export default ManagedNumberListStore;
